//  @flow

import React, { memo } from 'react'

import Messenger from '../Messenger'
import useFooterHeight from '@website/common/hooks/useFooterHeight'
import * as Styled from './styled'

const SiteMessengers = ({ messengersData: { settings, data } }) => {
  const addedMessengers = data.filter(messenger => messenger.isActive)
  const { alignment } = settings
  const footerHeight = useFooterHeight()

  return (
    <Styled.SiteMessengersWrapper
      alignment={alignment}
      className="site-messengers"
      additionalSpace={footerHeight}
    >
      {addedMessengers.map(messenger => {
        return (
          <Styled.SiteMessengerItem key={messenger.name}>
            <Messenger
              type={messenger.name}
              alignment={alignment}
              data={{
                ...(messenger.data || {}),
                value: messenger.value
              }}
            />
          </Styled.SiteMessengerItem>
        )
      })}
    </Styled.SiteMessengersWrapper>
  )
}

export default memo(SiteMessengers)
